import { useLatestBlock } from 'hooks/useLatestBlock'

const DEFAULT_MAX_BLOCK_AGE = 90

export function useIsValidBlock(block: number, maxBlockAge = DEFAULT_MAX_BLOCK_AGE): boolean {
  const { blockNumber } = useLatestBlock()

  if (!blockNumber) return false

  return Number(blockNumber) - block <= maxBlockAge
}
